<div class="carousel"
  [attr.id]="idStr"
>

  <!-- <div class="sr-only"
    tabindex="0"
    [attr.aria-label]="ariaLabel"
  ></div> -->

  <!----- slides ------>
  <div
    #carousel
    [attr.id]="idStr + '-items'"
    class="slides"
    tabindex="0"
    [attr.aria-label]="'Carousel: Slide #' + (activeSlides.current + 1) + ' is active'"
    aria-live="polite"
    role="group"
  >

    <!----- slide ----->
    <div
      #slide
      role="group"
      *ngFor="let carouselSlide of carouselSlides; let i = index"
      [class.is-active]="i === activeSlides.current"
      class="slide"
      [attr.aria-hidden]="i != activeSlides.current || false"
    >
      <ng-container [ngTemplateOutlet]="carouselSlide.tpl"></ng-container>
    </div>
    </div>

    <div class="static-content">
      <ng-content select="[staticContent]"></ng-content>
    </div>

    <!-- previous/ Carousel left arrow svg -->
    <a
      #next
      tabindex="0"
      class="next"
      role="button"
      (click)="select(activeSlides.previous)"
      *ngIf="slides.length > 1 && isNavigation"
      [attr.aria-label]="nextAriaLabel"
      [attr.aria-controls]="idStr + '-items'"
      (keydown.enter)="select(activeSlides.previous)">
        <img alt="previous" src="/credit-cards/commonui-assets/svgs/carousel3-svg/left-arrow.svg">
    </a>

    <!-- next/ Carousel right arrow svg -->
    <a
      class="prev"
      role="button"
      tabindex="0"
      (click)="select(activeSlides.next)"
      *ngIf="slides.length > 1 && isNavigation"
      [attr.aria-label]="prevAriaLabel"
      [attr.aria-controls]="idStr + '-items'"
      (keydown.enter)="select(activeSlides.next)">
      <img alt="next" class="chevron-right" src="/credit-cards/commonui-assets/svgs/carousel3-svg/right-arrow.svg">
  </a>

  <!--- indicators --->
  <div class="indicators" *ngIf="slides.length > 1 && isControls">

    <!--- NEXT/Chevron Left svg --->
    <a
      role="button"
      tabindex="0"
      class="chevron-next"
      (click)="select(activeSlides.previous)"
      *ngIf="slides.length > 1 && isNavigation"
      [attr.aria-label]="nextAriaLabel"
      [attr.aria-controls]="idStr + '-items'"
      (keydown.enter)="select(activeSlides.previous)">
        <img alt="previous" src="/credit-cards/commonui-assets/svgs/carousel3-svg/chevron-left.svg">
    </a>

    <!----- INDICATOR ----->
    <a
      tabindex="0"
      role="button"
      class="indicator"
      (click)="select(i)"
      (keydown.enter)="select(i)"
      [attr.id]="idStr + 'Dot' + (i + 1)"
      [attr.aria-controls]="idStr + '-items'"
      *ngFor="let carouselSlide of carouselSlides; let i = index"
      [class.is-active]="i === activeSlides.current"
      [attr.aria-label]="'carousel slide ' + (i + 1) + ' of ' + carouselSlides.length"
    ></a>

    <!--- PREV/Chevron Right svg --->
    <a
      tabindex="0"
      role="button"
      class="chevron-prev"
      (click)="select(activeSlides.next)"
      *ngIf="slides.length > 1 && isNavigation"
      [attr.aria-label]="prevAriaLabel"
      [attr.aria-controls]="idStr + '-items'"
      (keydown.enter)="select(activeSlides.next)">
      <img alt="next" src="/credit-cards/commonui-assets/svgs/carousel3-svg/chevron-right.svg">
    </a>
  </div>
</div>
